import Rollbar from 'rollbar'

// 1. Read env variables
const accessToken = import.meta.env.VITE_ROLLBAR_ACCESS_TOKEN
const environment = import.meta.env.VITE_ROLLBAR_ENV || 'development'

// 2. Configure Rollbar
const rollbarConfig = {
  accessToken: accessToken,
  captureUncaught: true,
  captureUnhandledRejections: true,
  payload: {
    environment: environment,
    client: {
      javascript: {
        source_map_enabled: true, // Enable if you plan to upload source maps
        code_version: '1.0.0', // useful for source map linking
        guess_uncaught_frames: true,
      },
    },
  },
}

// 3. Export the instance
export const rollbar = new Rollbar(rollbarConfig)
